import * as React from 'react';
import NumberFormat from 'react-number-format';

// Numeric input for the alternative-calculation screens (idem old CaseDetailsAlternativeCalculationPieces):
// a react-number-format field capped at 2 decimals. Used as MUI InputProps.inputComponent.
const NumberFormatCustom: React.FC<any> = (props) => {
  const { inputRef, onChange, value, ...other } = props;
  return (
    <NumberFormat
      {...other}
      value={value}
      getInputRef={inputRef}
      onValueChange={(values) => {
        if (values.floatValue !== parseFloat(value)) {
          onChange({ target: { value: values.value }, currentTarget: { value: values.value } });
        }
      }}
      thousandSeparator={false}
      decimalScale={2}
      allowNegative={false}
      isNumericString
    />
  );
};

export default NumberFormatCustom;
